module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main main--contentful"
  }, [_c('ui-article-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "group--sticky-sidebar"
  }, [(_vm.showSearch) ? _c('ui-search') : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.loading) ? _c('ui-module-loader', {
    key: "loader",
    attrs: {
      "messages": ['Please give us a moment load your content']
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64f6d20c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/contentful/Contentful.vue
// module id = 567
// module chunks = 0